import CroustilleElement from '../lib/CroustilleElement'
import Flickity from 'flickity'

class ProductImages extends CroustilleElement {
  constructor() {
    super('product-images')
  }

  get container() {
    return document.querySelector(this.childSelector('container'))
  }

  set active(value) {
    this.sliderActive = value
  }

  get active() {
    return this.sliderActive
  }

  evalState() {
    if (window.innerWidth >= 768) {
      this.active = false
    } else {
      this.active = true
    }
  }

  load() {
    this.evalState()

    if (this.active) {
      if (Flickity.data(this.container)) {
        this.slider = Flickity.data(this.container)
      } else {
        this.timeout = setTimeout(() => {
          this.slider = new Flickity(this.container, {
            pageDots: true,
            cellSelector: this.childSelector('slide'),
            freeScroll: false,
            contain: true,
            adaptiveHeight: true,
            autoPlay: 5000,
            prevNextButtons: false,
            draggable: true,
            pauseAutoPlayOnHover: false
          })
          // console.log('turbolinks:load', this.slider)
        }, 20)
      }
    } else {
      this.slider && this.slider.destroy()
      delete this.slider
    }
  }

  init() {
    this.load = this.load.bind(this)
    document.addEventListener('turbolinks:load', this.load)
  }

  resized() {
    this.load()
  }

  destroy() {
    // document.removeEventListener('turbolinks:load', this.load)
    // clearTimeout(this.timeout)
    this.slider && this.slider.destroy()
    delete this.slider
  }
}

export default ProductImages
